import * as Yup from 'yup'
import store from '../../../store'

import {
  AUDIENCE_NETWORK_CLASSIC,
  AUDIENCE_NETWORK_INSTREAM_VIDEO,
  AUDIENCE_NETWORK_REWARDED_VIDEO,
  FACEBOOK_FEED,
  FACEBOOK_INSTANT_ARTICLE,
  FACEBOOK_INSTREAM_VIDEO,
  FACEBOOK_MARKETPLACE,
  FACEBOOK_PROFILE_FEED,
  FACEBOOK_RIGHT_HAND_COLUMN,
  FACEBOOK_SEARCH,
  FACEBOOK_STORY,
  FACEBOOK_VIDEO_FEEDS,
  INSTAGRAM_EXPLORE,
  INSTAGRAM_REELS,
  INSTAGRAM_STORY,
  INSTAGRAM_STREAM,
  MESSENGER_MESSENGER_HOME,
  MESSENGER_SPONSORED_MESSAGES,
  MESSENGER_STORY
} from '../../Facebook/placements/fields'
import { LOCATION_LIST } from '../../ReusableFormFields/GeolocationsFields/fields'

// NAME
export const NAME = 'name'

// SPEND
export const MIN_SPEND_TARGET_LIFETIME = 'min_spend_target_lifetime'
export const SPEND_CAP_LIFETIME = 'spend_cap_lifetime'
export const MIN_SPEND_TARGET_DAILY = 'min_spend_target_daily'
export const SPEND_CAP_DAILY = 'spend_cap_daily'

// START DATE
export const START_DATE = 'date_start'
export const START_TIME = 'start_time'

// STOP DATE
export const STOP_DATE = 'date_stop'
export const STOP_TIME = 'stop_time'

// TARGET COST CAP, ROAS AVERAGE FLOOR
export const TARGET_COST_CAP = 'target_cost_cap'
export const ROAS_AVERAGE_FLOOR = 'roas_average_floor'

// AUDIENCE
export const AUDIENCE = 'audience'

// AGE
export const AGE = 'age'

// LANGUAGES
export const LANGUAGES = 'languages'

// PLACEMENT
export const PLACEMENT_POSITIONS = 'placement_positions'

// messenger

export const locationListValidation = Yup.string().test(
  LOCATION_LIST,
  'You are trying to add list with more than 500 locations. To target all selected locations you need to create separate line items, each with less than 500 locations in each.',
  selectedLocationList => {
    if (selectedLocationList) {
      const {
        location: { locationLists }
      } = store.getState()
      const locationListData =
        locationLists.results && locationLists.results.find(({ id }) => id === parseInt(selectedLocationList))

      return locationListData && locationListData.size <= 500
    } else {
      return true
    }
  }
)

export const placementPositionInitialValues = {
  [FACEBOOK_FEED]: false,
  [INSTAGRAM_STREAM]: false,
  [FACEBOOK_MARKETPLACE]: false,
  [FACEBOOK_PROFILE_FEED]: false,
  [FACEBOOK_VIDEO_FEEDS]: false,
  [FACEBOOK_RIGHT_HAND_COLUMN]: false,
  [INSTAGRAM_EXPLORE]: false,
  [MESSENGER_MESSENGER_HOME]: false,
  [INSTAGRAM_STORY]: false,
  [FACEBOOK_STORY]: false,
  [MESSENGER_STORY]: false,
  [INSTAGRAM_REELS]: false,
  [FACEBOOK_INSTREAM_VIDEO]: false,
  [AUDIENCE_NETWORK_INSTREAM_VIDEO]: false,
  [FACEBOOK_SEARCH]: false,
  [MESSENGER_SPONSORED_MESSAGES]: false,
  [FACEBOOK_INSTANT_ARTICLE]: false,
  [AUDIENCE_NETWORK_CLASSIC]: false,
  [AUDIENCE_NETWORK_REWARDED_VIDEO]: false
}

export const placementSafetyRules = {
  brand_safety_content_filter_levels: ['facebook_strict', 'an_strict'],
  excluded_publisher_categories: [
    'dating',
    'gambling',
    'debated_social_issues',
    'mature_audiences',
    'tragedy_and_conflict'
  ]
}

export const targetingRelaxationTypes = {
  targeting_relaxation_types: {
    custom_audience: 0,
    lookalike: 0
  }
}

export const recentLocationTypes = {
  location_types: ['home', 'recent']
}
